// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3zPUc","icon":"SortAdornment_icon__3FZ-d","up":"SortAdornment_up__DHdZX","down":"SortAdornment_down__28bds","active":"SortAdornment_active__3n39Y"};